import { createAsyncThunk } from '@reduxjs/toolkit';
import { ConsumerTypeService } from '../../services/ConsumerTypeService';
import { fetchConsumerTypesActionName } from './actionTypes';

const service = ConsumerTypeService;

export const fetchConsumerTypesAction = createAsyncThunk(fetchConsumerTypesActionName, async () => {
  return service.getConsumerTypes();
});
